import fetcher from 'api/fetcher';
import axios from 'axios';

interface ExistAdvertisingCampaignsData {
    existAdvertisingCampaigns: boolean;
}

type FetchWizardExistAdvCampaigns = (abortSignal?: AbortSignal) => Promise<boolean | null>;

export const fetchWizardExistAdvCampaigns: FetchWizardExistAdvCampaigns = (abortSignal) => {
    return fetcher
        .get<unknown, ExistAdvertisingCampaignsData>('/api/v1/campaigns/exist_advertising_campaigns', {
            signal: abortSignal,
        })
        .then(({ existAdvertisingCampaigns }) => existAdvertisingCampaigns)
        .catch((error) => {
            if (axios.isCancel(error) || abortSignal?.aborted) {
                return null;
            }
            throw error;
        });
};
